module.exports = __webpack_public_path__ + "img/overview-map-dropdown.6405d973.svg";